export default __webpack_public_path__ + "static/media/Seth_Icon.be2096f5.png";